// src/docs/DocsClaimRefunds.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsClaimRefunds = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Page Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 3 }}>
        Claiming Refunds
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 3 }}>
        In the event that a project share sale does not meet its soft cap, investors are entitled to a full refund of their contributions.
        This guide explains the refund process, the conditions under which refunds are enabled, and the corresponding smart contract logic.
      </Typography>

      {/* When Refunds Are Enabled */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        When Are Refunds Enabled?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Refunds become available when the total funds raised during the sale fall short of the predefined soft cap.
        During the sale finalization, if the soft cap is not met, the contract automatically triggers refunds by calling the internal function <code>_enableRefunds()</code>.
        This function sets the <code>isRefundEnabled</code> flag to true, allowing investors to claim their BNB back.
      </Typography>

      {/* How to Claim a Refund */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        How to Claim a Refund
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Once refunds are enabled, any investor who contributed to the share sale can claim their refund by invoking the <code>claimRefund()</code> function.
        The process involves:
        <br /><br />
        1. Verifying that refunds are enabled (<code>isRefundEnabled == true</code>).
        <br />2. Checking that your contribution (stored in the <code>contributions</code> mapping) is greater than zero.
        <br />3. Resetting your contribution to zero to prevent multiple refunds.
        <br />4. Transferring the contributed BNB back to your wallet.
        <br />5. Emitting a <code>Refunded</code> event to log the transaction.
      </Typography>

      {/* Additional Considerations */}
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Note that:
        <br /><br />
        • Refunds are processed in BNB and will be sent directly to the wallet that made the contribution.
        <br />• If you attempt to claim a refund before the soft cap is met and refunds are enabled, the transaction will fail.
        <br />• The refund mechanism ensures that once you claim your refund, your contribution record is reset to prevent duplicate claims.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        By understanding the refund process and the underlying smart contract logic, you can confidently navigate your investments on CrowdLaunch.
        Always verify that refunds are enabled on the project page before initiating a refund claim, and ensure that your wallet is properly connected.
      </Typography>
    </Container>
  );
};

export default DocsClaimRefunds;
